import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const changeSignupEmail = (email) => {
    return axios.post(`${SYMFONY_API_BASE_URL}/change-signup-email`, {
        email,
    });
};
export default changeSignupEmail;
